/**
 * Main Collection Page JavaScript
 * Handles color banner slider functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    initColorBannerSlider();
  });
  
  function initColorBannerSlider() {
    const slider = document.getElementById('color-banner-slider');
    const prevBtn = document.querySelector('.collection-color-banner__nav--prev');
    const nextBtn = document.querySelector('.collection-color-banner__nav--next');
    
    if (!slider || !prevBtn || !nextBtn) return;
    
    let isScrolling = false;
    
    function updateButtonStates() {
      const scrollLeft = slider.scrollLeft;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      
      prevBtn.disabled = scrollLeft <= 0;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }
    
    function scrollTo(direction) {
      if (isScrolling) return;
      
      isScrolling = true;
      const itemWidth = slider.querySelector('.collection-color-banner__item').offsetWidth + 12; // width + gap
      const scrollAmount = direction === 'next' ? itemWidth : -itemWidth;
      
      slider.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
      
      setTimeout(() => {
        isScrolling = false;
        updateButtonStates();
      }, 300);
    }
    
    // Event listeners
    prevBtn.addEventListener('click', () => scrollTo('prev'));
    nextBtn.addEventListener('click', () => scrollTo('next'));
    slider.addEventListener('scroll', updateButtonStates);
    
    // Initial state
    updateButtonStates();
    
    // Update on resize
    window.addEventListener('resize', updateButtonStates);
  }